import React, { useState, useCallback } from 'react';
import { Form, FormGroup, FormControl, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

/**
 * Search component for blog content.
 * Redirects to the blog list page with query string on search submit.
 */
const Search = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    const handleInputChange = useCallback((event) => {
        setSearchTerm(event.target.value);
    }, []);

    const handleFormSubmit = useCallback(
        (event) => {
            event.preventDefault();
            const query = searchTerm.trim();
            if (query) {
                navigate(`/blog?s=${encodeURIComponent(query)}`);
            }
        },
        [navigate, searchTerm]
    );

    return (
        <section className="search-wrapper common-wrapper mb-4 position-relative">
            <h3 className="mb-4 fw-500 text-uppercase text-4">Search</h3>

            <Form onSubmit={handleFormSubmit} role="search" aria-label="Blog search form">
                <FormGroup className="position-relative">
                    <FormControl
                        type="search"
                        name="search"
                        value={searchTerm}
                        onChange={handleInputChange}
                        placeholder="Search here..."
                        className="fw-500 fs-6 pt-2 pb-2"
                        aria-label="Search input"
                    />

                    <Button
                        type="submit"
                        className="fw-700 fs-6 position-absolute"
                        aria-label="Submit search"
                    >
                        <FontAwesomeIcon icon={faSearch} />
                    </Button>
                </FormGroup>
            </Form>
        </section>
    );
};

export default React.memo(Search);
